/**
 * Legacy clients list — /admin/clients (redirect stub).
 *
 * The old firm-tenant trust list is retired: firms hold clients exclusively
 * through the Client Book (each client is a first-class tenant, operated via
 * act-as). This route redirects so existing bookmarks / links don't hit a
 * dead stub.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/clients/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/client-book' });
  },
});
